module.exports = "/images/ver-ocultar.svg?05a2c77a397ecacae0f79306f95944ae";